export default "/learning-portal/workshops";
